import { Component } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { AppleDevice, Device } from '@era/locations-sdk';
import type { DeviceStoreModels } from '@era/stores';
import { AppleDeviceStoreSelectors, DeviceStoreActions, DeviceStoreSelectors } from '@era/stores';
import { Store } from '@ngrx/store';
import { Observable, ReplaySubject, merge } from 'rxjs';
import { first, withLatestFrom } from 'rxjs/operators';
import { DeviceLinkSelectorComponent } from '../device-link-selector/device-link-selector.component';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'era-device-kiosk',
  templateUrl: './device-kiosk.container.html',
  styleUrls: ['./device-kiosk.container.scss'],
  imports: [DeviceLinkSelectorComponent, RouterLink, AsyncPipe],
})
export class DeviceKioskContainerComponent {
  private readonly selectionSubject = new ReplaySubject<DeviceStoreModels.SelectedLocation>(1);
  public readonly data$: Observable<DeviceStoreModels.SelectedLocation>;
  public readonly selection$: Observable<DeviceStoreModels.SelectedLocation>;

  constructor(
    private readonly appleDeviceStore: Store<AppleDevice>,
    private readonly deviceStore: Store<Device>,
    private readonly router: Router,
    private readonly route: ActivatedRoute
  ) {
    this.data$ = this.deviceStore.select(DeviceStoreSelectors.selectSelectedLocation);
    this.selection$ = merge(this.data$, this.selectionSubject);
  }

  public updateSelection(selectedLocation) {
    this.selectionSubject.next(selectedLocation);
  }

  public kiosk() {
    this.appleDeviceStore
      .select(AppleDeviceStoreSelectors.selectCurrentDeviceLink)
      .pipe(withLatestFrom(this.selection$), first())
      .subscribe(([link, selection]) => {
        this.deviceStore.dispatch(
          DeviceStoreActions.DeviceKioskViewActions.deviceMarkedAsKiosk({
            link,
            brandId: selection.brandId,
            locationId: selection.locationId,
          })
        );
        void this.router.navigate(['../'], { relativeTo: this.route });
      });
  }
}
